import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon, SearchIcon, FilterIcon, EyeIcon, EditIcon, CopyIcon, MoreHorizontalIcon, SendIcon, CalendarIcon } from 'lucide-react';
const Newsletters = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const newsletters = [{
    id: '1',
    title: 'May Product Updates',
    template: 'Monthly Update',
    status: 'sent',
    recipients: 1250,
    sentDate: 'May 15, 2023',
    createdBy: 'Admin User'
  }, {
    id: '2',
    title: 'Special Offer: Summer Promotion',
    template: 'Promotional',
    status: 'sent',
    recipients: 850,
    sentDate: 'May 10, 2023',
    createdBy: 'Marketing Team'
  }, {
    id: '3',
    title: 'June Newsletter Draft',
    template: 'Monthly Update',
    status: 'scheduled',
    recipients: 1500,
    sentDate: 'Jun 1, 2023 at 9:00 AM',
    createdBy: 'Content Editor'
  }, {
    id: '4',
    title: 'Welcome Series: New Entrepreneurs',
    template: 'Welcome',
    status: 'draft',
    recipients: 45,
    sentDate: '-',
    createdBy: 'Admin User'
  }, {
    id: '5',
    title: 'Q2 Survey Request',
    template: 'Survey Template',
    status: 'draft',
    recipients: 0,
    sentDate: '-',
    createdBy: 'Research Team'
  }, {
    id: '6',
    title: 'April Newsletter',
    template: 'Monthly Update',
    status: 'sent',
    recipients: 1180,
    sentDate: 'Apr 15, 2023',
    createdBy: 'Admin User'
  }];
  const filteredNewsletters = newsletters.filter(newsletter => {
    const matchesSearch = newsletter.title.toLowerCase().includes(searchQuery.toLowerCase()) || newsletter.template.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = statusFilter === 'all' || newsletter.status === statusFilter;
    return matchesSearch && matchesStatus;
  });
  const getStatusBadge = (status: string) => {
    const statusConfig = {
      draft: {
        bg: 'bg-secondary-100',
        text: 'text-secondary-800',
        label: 'Draft'
      },
      scheduled: {
        bg: 'bg-blue-100',
        text: 'text-blue-800',
        label: 'Scheduled'
      },
      sent: {
        bg: 'bg-green-100',
        text: 'text-green-800',
        label: 'Sent'
      },
      failed: {
        bg: 'bg-red-100',
        text: 'text-red-800',
        label: 'Failed'
      }
    };
    const config = statusConfig[status as keyof typeof statusConfig] || statusConfig.draft;
    return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`} data-id="element-320">
        {config.label}
      </span>;
  };
  return <div className="space-y-6" data-id="element-321">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between" data-id="element-322">
        <h2 className="text-2xl font-bold text-secondary-900" data-id="element-323">Newsletters</h2>
        <Link to="/newsletters/create" className="btn btn-primary flex items-center justify-center mt-3 sm:mt-0" data-id="element-324">
          <PlusIcon size={16} className="mr-1" data-id="element-325" />
          <span data-id="element-326">Create Newsletter</span>
        </Link>
      </div>
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-id="element-327">
        <div className="relative flex-1 max-w-md" data-id="element-328">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-329">
            <SearchIcon size={18} className="text-secondary-400" data-id="element-330" />
          </div>
          <input type="text" placeholder="Search newsletters..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-10 input" data-id="element-331" />
        </div>
        <div className="flex items-center space-x-4" data-id="element-332">
          <div className="flex items-center space-x-2" data-id="element-333">
            <FilterIcon size={16} className="text-secondary-500" data-id="element-334" />
            <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="border border-secondary-300 rounded-md text-secondary-700 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500" data-id="element-335">
              <option value="all" data-id="element-336">All Status</option>
              <option value="draft" data-id="element-337">Draft</option>
              <option value="scheduled" data-id="element-338">Scheduled</option>
              <option value="sent" data-id="element-339">Sent</option>
              <option value="failed" data-id="element-340">Failed</option>
            </select>
          </div>
        </div>
      </div>
      <div className="table-container" data-id="element-341">
        <table className="table" data-id="element-342">
          <thead className="table-header" data-id="element-343">
            <tr data-id="element-344">
              <th className="table-header-cell" data-id="element-345">Newsletter Title</th>
              <th className="table-header-cell" data-id="element-346">Template</th>
              <th className="table-header-cell" data-id="element-347">Status</th>
              <th className="table-header-cell" data-id="element-348">Recipients</th>
              <th className="table-header-cell" data-id="element-349">Sent/Scheduled Date</th>
              <th className="table-header-cell" data-id="element-350">Created By</th>
              <th className="table-header-cell" data-id="element-351">Actions</th>
            </tr>
          </thead>
          <tbody className="table-body" data-id="element-352">
            {filteredNewsletters.map(newsletter => <tr key={newsletter.id} className="table-row" data-id="element-353">
                <td className="table-cell font-medium" data-id="element-354">{newsletter.title}</td>
                <td className="table-cell" data-id="element-355">{newsletter.template}</td>
                <td className="table-cell" data-id="element-356">
                  {getStatusBadge(newsletter.status)}
                </td>
                <td className="table-cell" data-id="element-357">
                  {newsletter.recipients.toLocaleString()}
                </td>
                <td className="table-cell" data-id="element-358">{newsletter.sentDate}</td>
                <td className="table-cell" data-id="element-359">{newsletter.createdBy}</td>
                <td className="table-cell" data-id="element-360">
                  <div className="flex items-center space-x-2" data-id="element-361">
                    {newsletter.status === 'draft' && <button className="p-1 rounded-md text-secondary-500 hover:bg-secondary-100" title="Send" data-id="element-362">
                        <SendIcon size={16} data-id="element-363" />
                      </button>}
                    {newsletter.status === 'scheduled' && <button className="p-1 rounded-md text-secondary-500 hover:bg-secondary-100" title="Reschedule" data-id="element-364">
                        <CalendarIcon size={16} data-id="element-365" />
                      </button>}
                    <button className="p-1 rounded-md text-secondary-500 hover:bg-secondary-100" title="Preview" data-id="element-366">
                      <EyeIcon size={16} data-id="element-367" />
                    </button>
                    {(newsletter.status === 'draft' || newsletter.status === 'scheduled') && <Link to={`/newsletters/edit/${newsletter.id}`} className="p-1 rounded-md text-secondary-500 hover:bg-secondary-100" title="Edit" data-id="element-368">
                        <EditIcon size={16} data-id="element-369" />
                      </Link>}
                    <button className="p-1 rounded-md text-secondary-500 hover:bg-secondary-100" title="Clone" data-id="element-370">
                      <CopyIcon size={16} data-id="element-371" />
                    </button>
                    <button className="p-1 rounded-md text-secondary-500 hover:bg-secondary-100" title="More options" data-id="element-372">
                      <MoreHorizontalIcon size={16} data-id="element-373" />
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
};
export default Newsletters;